import { graphql } from '@lib/graphql'
import { execute } from '@lib/graphql/execute'
import { CartCreateInput } from '@lib/graphql/graphql'

const cartCreateMutationDocument = graphql(`
  mutation CartCreate($input: CartCreateInput!) {
    cartCreate(input: $input) {
      cart {
        ...CartDetail
      }
      errors {
        __typename
      }
    }
  }
`)

export const cartCreate = async (input: CartCreateInput) => {
  return await execute(cartCreateMutationDocument, { input })
}
